<ng-container *ngIf="environments | environmentCheck : devQa : stageProdDemo">
  <ng-content></ng-content>
</ng-container>
